import { render, staticRenderFns } from "./PhotoBasedSectionDysfunctionV2.vue?vue&type=template&id=5011f8ed&scoped=true"
import script from "./PhotoBasedSectionDysfunctionV2.vue?vue&type=script&lang=js"
export * from "./PhotoBasedSectionDysfunctionV2.vue?vue&type=script&lang=js"
import style0 from "./PhotoBasedSectionDysfunctionV2.vue?vue&type=style&index=0&id=5011f8ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5011f8ed",
  null
  
)

export default component.exports